import React from "react";
import styles from "../../styles/components/card.module.scss";
import Icons from "../../public/assets/svg";
import Router from "next/router";
import { useDispatch } from "react-redux";
import { saveCurrentBot } from "../../redux/storeBot/actions";
import endpoints from "../../utility/endpoints";

export default function index(props) {
  const dispatch = useDispatch();
  const {
    data: {
      _source: { leadPlatform, processName, area, subArea, botID,botExternalId, status, cluster },
    },
  } = props;

  //console.log(leadPlatform, "LEADPLATFORM")
//console.log(status, "status")

 

  const goToPage = () => {
    // dispatch(saveCurrentBot(botID))
    // Router.push("/botDetails");
    const encBotId=window.btoa(botID)
    window.open(endpoints.redirectUriLogin+`botDetails?botID=${encBotId}`
    //   {
    //   pathname: "/botDetails",
    //   query: { botID: botID },
    // }
    );
  };

  function camelize(str) {
    return str.toString()
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.cardHead}>
        <div className={styles.icon}>
          <Icons name={camelize(leadPlatform)} className={styles.shoppingIcon} />
        </div>
        <div className={styles.text} style={{lineHeight:"21px"}}>
          <p className={styles.code}>
            {status === "Demand/New Ideas" ? "D" : ""}{botExternalId || botID}
          </p>
          <p className={styles.label} style={{marginBottom:".3em"}}>{leadPlatform}</p>
        </div>
      </div>
      <div className={styles.cardBody}>
        <p className={styles.title}>{processName.length > 30 ? processName.slice(0,30) + "..." : processName}</p>
        <p className={`${styles.label} ${styles[`${status == "Design/Feasibility"? "designFeasibility": camelize(status)}Status`]}`}>
          {status}
        </p>
        <p className={styles.content}>
          <span className={styles.title}>Area</span>
          <span className={styles.text}>{area}</span>
        </p>
        <p className={styles.content}>
          <span className={styles.title}>Cluster</span>
          <span className={styles.text}>{cluster}</span>
        </p>
      </div>
      <div className={styles.cardFoot}>
        <span className={styles.actionBtn} onClick={goToPage}>
          View Details
        </span>
      </div>
    </div>
  );
}
